import { isFacebookAdTraffic } from '@/utils/eventTracking'
import { parseSiteConfigData } from '@/utils/siteSeo'

export const FACEBOOK_ADS_ONLY_TRACKING_CONFIG_KEY = 'facebookAdsOnlyTracking'

const normalizeBoolean = (value) => {
  if (value === true || value === 1) return true
  if (typeof value !== 'string') return false

  return ['1', 'true'].includes(value.trim().toLowerCase())
}

export function isFacebookAdsOnlyTrackingEnabled(configData) {
  const parsedConfigData = parseSiteConfigData(configData)
  return normalizeBoolean(parsedConfigData?.[FACEBOOK_ADS_ONLY_TRACKING_CONFIG_KEY])
}

export function shouldReportFacebookTracking(configData) {
  if (!isFacebookAdsOnlyTrackingEnabled(configData)) {
    return true
  }

  return isFacebookAdTraffic()
}
